export const AUTO_CLOSE_DURATION_IN_MS = 2500;
export const TOASTS_LIMIT = 3;
